module.exports = __webpack_public_path__ + "03_glasses_red.fbed9231.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer4/03_glasses_red.png
// module id = cPYL
// module chunks = 0